exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#SpReschedulingList[data-v-7a9171d8]{\n  width: 100%;\n  text-align: center;\n}\ntable[data-v-7a9171d8]{\n  width: 80%;\n  margin: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7a9171d8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/ReschedulingPage/SpreschedulingList.vue
// module id = 533
// module chunks = 0